import { inject, Injectable } from '@angular/core';
import { Storage,UploadTaskSnapshot,ref, uploadBytesResumable, getDownloadURL, StorageReference, UploadTask, TaskEvent } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, lastValueFrom, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FstorageService {

  _storage = inject(Storage);
  _http = inject(HttpClient);

  constructor() { }

  ref(storagePath:string):StorageReference {
    return ref(this._storage, storagePath);
  }

  async getDownloadUrl(ref: StorageReference):Promise<string>{
    return getDownloadURL(ref);
  }

  uploadFileTask(ref:StorageReference, data: Blob | Uint8Array | ArrayBuffer):UploadTask {
    const task = uploadBytesResumable(ref, data);
    console.log(task.on);
    return task;
  }  
  
  uploadFileForm(storagePath:string, event:any):Observable<UploadTask> {
    const filePath = storagePath;
    const myRef = this.ref(filePath);
    const file = event.target.files[0];
    const task = this.uploadFileTask(myRef, file);
    return of(task);
  }

  uploadFileUrl(storagePath:string, url:string):Observable<UploadTask> {
    const filePath = storagePath;
    const myRef = this.ref(filePath);
    return (this._http.get(url, { responseType: 'arraybuffer' }).pipe(map(
        (file)=>{
          console.log(file);
          const task = this.uploadFileTask(myRef,file);
          console.log(task.on);
          if (task == undefined || !task.on){  
            throw "No task defined";
          }
          return task as UploadTask;
        }
      )));
    // return firstValueFrom( this._http.get(url, { responseType: 'arraybuffer' }).pipe(map(
    //   (file)=>{
    //     return this.uploadFileTask(myRef,file);
    //   }
    // )));

  }

}


